import { GetServerSideProps, NextPage } from 'next';
import React from 'react';

import { pagesConfigStore } from '~/atomic/atom/links/pagesConfigStore';
import { LayoutType } from '~/atomic/layout/DefaultLayout';
import { PageTemplate } from '~/atomic/organism/PageTemplate/PageTemplate';
import { Refriver } from '~/atomic/page/refriver/Refriver';
import { checkAuthToken } from '~/feature/authorization/checkAuthToken';
import { SiteTemplate } from '~/feature/template/SiteTemplate';
import { createStore, RootState } from '~/store';

const RefriverPage: NextPage & LayoutType = () => {
  const title = 'Партнерская программа | Произведения авторов полностью на Bookriver';
  const description = 'Партнерская программа — литературно-издательская площадка Bookriver'
  + ' ⭐ Серии книг ⭐ Полные циклы произведений'
  + ' ⭐ Комментарии и отзывы читателей ⭐ Скачать произведения'
  + ' полностью в формате fb2 ✉ Найдите интересную'
  + ' книгу на нашем сайте и читайте удобно онлайн';

  return (
    <PageTemplate
      isPublic={pagesConfigStore.refriver.isPublic}
      seo={{
        title,
        description,
        canonical: pagesConfigStore.refriver.url,
      }}
      content={(
        <Refriver />
      )}
    />
  );
};

RefriverPage.getLayout = (page) => (
  <SiteTemplate>
    { page }
  </SiteTemplate>
);

export const getServerSideProps: GetServerSideProps<
{ state: RootState; },
{ genres: string[]; }
> = async (context) => {
  const { dispatch, store } = await createStore();
  const isLoggedIn = await checkAuthToken(context, dispatch);

  const state = store.getState();
  return { props: { state } };
};

export default RefriverPage;
